import { Color, Component, SvgGraphics } from '@tencent/alloy-renderer';

/**
 * 编辑区 - 对齐线
 */
export class SnapLineElement extends Component {
    private scale: number;
    private lines: any;
    private components: Array<SvgGraphics>;

    public constructor(lines, scale) {
        super();
        this.lines = lines;
        this.scale = scale;
        this.components = [];
        this.renderSnapLine(lines);
    }

    public dispose = () => {
        super.dispose();
        this.components.forEach((comp) => {
            this.removeChild(comp);
            comp.dispose?.();
        });
        this.components = [];
    };

    /**
     * 对齐线绘制
     */
    private renderSnapLine(lines) {
        lines?.length && lines.forEach((line) => {
            const width = line[1] === 0 ? line[5].right - line[5].left : 1 / this.scale;
            const height = line[1] === 1 ? line[5].bottom - line[5].top : 1 / this.scale;
            let top = line[1] === 0 ? line[0] : line[5].top;
            let left = line[1] === 1 ? line[0] : line[5].left;
            left = line[1] === 1 ? left - (width / 2) : left;
            top = line[1] === 0 ? top - (height / 2) : top;

            const path = `M ${left} ${top} L ${width + left} ${height + top}`;
            const SnapLinePath = new SvgGraphics(path);
            SnapLinePath.lineStyle.color = Color.fromHex('#E6CF63');
            SnapLinePath.lineStyle.width = 2;
            this.addChild(SnapLinePath);
            this.components.push(SnapLinePath);
        });
    }
}
